import { UpsellCardAction, UpsellCardDismiss } from '../models/upsell-card-props';

export const DismissButton: React.FC<{ dismiss: UpsellCardDismiss }> = ({ dismiss }) => (
    <div className="hover-reveal">
        <s-button variant="tertiary" icon="x" {...dismiss} />
    </div>
);

export const ActionButton: React.FC<{ action: UpsellCardAction; fill?: boolean }> = ({
    action: { label, ...buttonProps },
    fill,
}) => (
    <s-button inlineSize={fill ? 'fill' : undefined} {...buttonProps}>
        {label}
    </s-button>
);
